import Grid from '@mui/material/Grid';
import ShippingSearchDatagridComponent from './_sections/_datagrid/ShippingSearchDatagridComponent';
import ShippingSearchFooterComponent from './_sections/_footer/ShippingSearchFooterComponent';
import ShippingSearchHeaderComponent from './_sections/_header/ShippingSearchHeaderComponent';

const ShippingSearchComponent = () => {
  return (
    <Grid container>
      <ShippingSearchHeaderComponent />
      <ShippingSearchDatagridComponent />
      <ShippingSearchFooterComponent />
    </Grid>
  );
};

export default ShippingSearchComponent;
